import mainBackgroundPattern from '@assets/images/backgrounds/main-background-pattern.png';
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100%',
        backgroundColor: 'rgba(255,255,255,0.2)',
    },
    backgroundOverlay: {
        backgroundColor: theme.palette.background.default,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.6,
        zIndex: -1,
    },
    background: {
        backgroundImage: `url(${mainBackgroundPattern})`,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -2,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
}));
